import React from 'react';

function isTrivialHref(href) {
	return !href || href.trim() === '#';
}

const SafeAnchor = React.forwardRef(
	(
		{
			as: Component = 'a',
			disabled,
			onKeyDown,
			...props
		},
		ref
	) => {
		const handleClick = event => {
			const { href, onClick } = props;

			if (disabled || isTrivialHref(href)) {
				event.preventDefault();
			}

			if (disabled) {
				event.stopPropagation();
				return;
			}

			if (onClick) {
				onClick(event);
			}
		};

		/* eslint-disable */
		if (isTrivialHref(props.href)) {
			props.role = props.role || 'button';
			// we want to make sure there is a href attribute on the node
			// otherwise, the cursor incorrectly styled (except with role='button')
			props.href = props.href || '#';
		}

		if (disabled) {
			props.tabIndex = -1;
			props['aria-disabled'] = true;
		}

		return (
			<Component
				ref={ref}
				{...props}
				onClick={handleClick}
			/>
		);
		/* eslint-enable */
	}
);

export default SafeAnchor;
